export interface EvaluationContext {
  userId?: string;
  deviceId?: string;
}

export interface FlagEvaluation {
  flagKey: string;
  variant: string | null;
  attachment: string | null;
  match: boolean;
}

export interface FeatureFlagAdapter {
  readonly name: string;
  initialize: () => Promise<void>;
  evaluate: (flagKey: string, context: EvaluationContext) => Promise<FlagEvaluation>;
}

export function noMatch(flagKey: string): FlagEvaluation {
  return { flagKey, variant: null, attachment: null, match: false };
}
